import * as React from 'react';
import { Button, ButtonGroup } from "@mui/material";
import styles from "../css/InstallButton.module.css";
import { MouseEventHandler } from "react";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useLoginValidator } from '../hooks/useLoginValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown, faCaretDown } from '@fortawesome/free-solid-svg-icons';

interface InstallButtonProps {
  handleOpenModal: MouseEventHandler,
  handleGadgetDownload: MouseEventHandler
}

const options = ['Install the Agent', 'Download the File'];

export const InstallButton = ({handleOpenModal, handleGadgetDownload}: InstallButtonProps) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const { validateLogin } = useLoginValidator();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    validateLogin(handleOpenModal, [event]);
  };
  
  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    switch(index) {
      case 0:
        validateLogin(handleOpenModal, [event]);
        break;
      case 1:
        validateLogin(handleGadgetDownload, [event]);
        break;
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button" className={styles.buttonGroup}>
        <Button 
          data-testid="install-btn" 
          onClick={(event) => handleClick(event)}
          className={styles.downloadButton} 
          startIcon={<FontAwesomeIcon icon={faAnglesDown} />}>
            Install
          </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <FontAwesomeIcon icon={faCaretDown} style={{color: "#fff"}}/>
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};